import { useState, useCallback } from "react";
import { PlayButtonDark } from "../../assets/svgIcons/PlayButtonDark";   
import { PlayButtonLight } from "../../assets/svgIcons/PlayButtonLight"; 
import "./cokeStudioPlaylist.scss";
import backArrow from "../../assets/icons/backarrow.svg";
import { trackClickEvent } from "src/analytics/gtm";

type ButtonState = "idle" | "hover" | "pressed";
type ColorMode = "light" | "dark";

interface CokeStudioPlaylistWidgetProps {
  spotifyPlaylistUrl?: string;
  mode?: ColorMode;
  className?: string;
}

const CokeStudioPlaylistWidget: React.FC<CokeStudioPlaylistWidgetProps> = ({
  spotifyPlaylistUrl = "https://open.spotify.com/embed/playlist/37i9dQZF1DWXRqgorJj26U?utm_source=generator",
  mode = "light",
  className = "",
}) => {
  const [isFlipped, setIsFlipped] = useState<boolean>(false);
  const [btnState, setBtnState] = useState<ButtonState>("idle");
 const pushClick = (payload: Parameters<typeof trackClickEvent>[0]): void => {
         trackClickEvent(payload);
       };
  const handleFlipOpen = useCallback(() => {
    pushClick({
      module: 'hero',
      module_title: 'Spotify widget',
      click_text: `Coke Studio Playlist`,
      click_url: `n/a`,
      click_element: 'card',
    });
    setBtnState("idle");
    setIsFlipped(true);
  }, []);

  const handleFlipClose = useCallback(() => {
    setIsFlipped(false);
  }, []);

  const PlayButton = mode === "dark" ? PlayButtonDark : PlayButtonLight;

  return (
    <div
      className={`csw-scene ${className} rounded-[24px] `}
      aria-label="Coke Studio Playlist Widget"
    >
      <div className={`csw-card ${isFlipped ? "flipped" : ""}`}>

        <div className="csw-face csw-face--front">
          <button
            className="csw-front-btn"
            aria-label="Open Coke Studio playlist"
            onClick={handleFlipOpen}
            onMouseEnter={() => setBtnState("hover")}
            onMouseLeave={() => setBtnState("idle")}
            onMouseDown={() => setBtnState("pressed")}
            onMouseUp={() => setBtnState("hover")}
            onTouchStart={() => setBtnState("pressed")}
            onTouchEnd={() => {
              setBtnState("idle");
              handleFlipOpen();
            }}
          >
            <PlayButton state={btnState} />
          </button>
        </div>

        <div className="csw-face csw-face--back">
          <button
              className="csw-back-btn"
              aria-label="Close playlist"
              onClick={handleFlipClose}
            >
              <img src={backArrow} alt="Back" />
            </button>
          <div className="csw-back-inner">
            {isFlipped && (
              <iframe
                title="Coke Studio Playlist"
                src={spotifyPlaylistUrl}
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              />
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default CokeStudioPlaylistWidget;